export default __webpack_public_path__ + "static/media/pom_alone.f06fb517.png";